import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedDateRange: {
    selectedDate: null,
    start: null,
    end: null,
  },
  activeTabState: "",
};

const dateFilterState = createSlice({
  name: "Active Data",
  initialState,
  reducers: {
    setActiveTabState(state, action) {
      state.activeTabState = action.payload;
    },
    setSelectedDateRange(state, action) {
      state.selectedDateRange = action.payload;
    },
  },
});

export const dateFilterStateActions = dateFilterState.actions;

export default dateFilterState.reducer;
